/* eslint-disable max-len */
import { useEffect, useState, useCallback, useRef } from "react"
import { dataService } from "../../../services/dataService"
import { useNavigate, useParams } from "react-router-dom";
import config from "../../../config";
import { Auth } from "aws-amplify";
import { io } from "socket.io-client";
import { Triangle } from "react-loader-spinner";
import PlaceBidCard from "../carousel-view/PlaceBidCard";

export default function LeaderBoardView(){
    const { uid } = useParams();
    const [socket,setSocket] = useState(null);
    const [lots, setLots] = useState([])
    const [currentLotIndex, setCurrentLotIndex] = useState(0);
    const [placeBidQueue, setPlaceBidQueue] = useState([]);
    const [currentPlaceBid, setCurrentPlaceBid] = useState(null);
    const [showPlaceBid, setShowPlaceBid] = useState(false);
    const [pausedLotIndex, setPausedLotIndex] = useState(null);
    const [auctionData, setAutcionData] = useState({});
    const [loading, setLoading] = useState(true);
    const Navigate = useNavigate();

    const wakeLockRef = useRef(null);

    useEffect(() => {
        let isSupported = "wakeLock" in navigator;

        const requestWakeLock = async () => {
            try {
                if (isSupported) {
                    wakeLockRef.current = await navigator.wakeLock.request("screen");
                    console.log("Wake lock is active");
                    wakeLockRef.current.addEventListener("release", () => {
                        console.log("Wake lock was released");
                    });
                }
            } catch (err) {
                console.error(`${err.name}, ${err.message}`);
            }
        };

        // Initial request
        requestWakeLock();

        // Re-request on visibility change
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                requestWakeLock();
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            if (wakeLockRef.current) {
                wakeLockRef.current.release();
                wakeLockRef.current = null;
            }
        };
    }, []);

    const getLeaderboardData = async ()=>{
        const response = await dataService.GetLeaderboard(uid)
        if(response.error == false){
            setAutcionData(response.data.data);
            if(response.data.data.status!=="Accepting bids" && response.data.data.status!=="Published"){
                Navigate('/page-not-found');
            }
        }
    }

    const socketConnection = async(lots)=>{
        const idToken = await Auth.currentSession()
    
        if(socket == null){
            const socketConn = io(config.SOCKETURL, {
                transports: ['websocket'],
                auth: {
                    token: idToken.getIdToken().getJwtToken(),
                    type: "seller"
                },
                reconnection: true
            })
    
            setSocket(socketConn);
    
            lots.map((lot)=>{
                socketConn.on('authorization', (message)=>{
                    if(message.success_status == true){
                        socketConn.emit('joinBidRoom', lot?._id, "seller");
                    }
                })
            })
                
            socketConn?.on('placeBid',(message)=>{
                if(message.success==true && message.newCurrentLotDetails){
                    const lotDetails = message.newCurrentLotDetails;
                    setLots(prevLots => 
                        prevLots.map(lot => 
                            lot._id === lotDetails._id 
                                ? {
                                    ...lot,
                                    ...(lotDetails.bid_amount && { current_bid: lotDetails.bid_amount }),
                                    ...(lotDetails.paddle_number && { paddle_number: lotDetails.paddle_number })
                                }
                                : lot
                        )
                    );
                    setPlaceBidQueue(prev => [...prev, lotDetails._id]);
                    setCurrentLotIndex(prevIndex => {
                        if (!showPlaceBid) {
                            setPausedLotIndex(prevIndex);
                        }
                        return prevIndex;
                    });
                }
            })
    
        }else{
            lots.map((lot)=>{
                socket.emit('joinBidRoom', lot?._id, "seller");
            })
        }
    }

    const fetchLots = async() =>{
        let endpoint = `?auction_id=${uid}&per_page=500`
        const response = await dataService.LotList(endpoint)
        if(response.error == false) {
            setLots(response.data.data)
            socketConnection(response.data.data)
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!showPlaceBid) {
            const interval = setInterval(() => {
                setCurrentLotIndex((prevIndex) => {
                    const nextIndex = prevIndex + 1;
                    return nextIndex >= lots.length ? 0 : nextIndex;
                });
            }, 3000);

            return () => clearInterval(interval);
        }
    }, [lots.length, showPlaceBid]);

    useEffect(() => {
        if (placeBidQueue.length > 0 && !showPlaceBid) {
            const nextBid = lots.find(lot => lot._id === placeBidQueue[0]) || currentLot
            setCurrentPlaceBid(nextBid);
            setShowPlaceBid(true);
      
            // Remove from queue
            setPlaceBidQueue(prev => prev.slice(1));
        }
    }, [placeBidQueue.length, showPlaceBid]);

    // Handle hiding the place bid overlay after 3 seconds
    useEffect(() => {
        if (showPlaceBid) {
            const timer = setTimeout(() => {
                setShowPlaceBid(false);
                setCurrentPlaceBid(null);
                setCurrentLotIndex(pausedLotIndex);
                setPausedLotIndex(null);
            }, 3000);
      
            return () => {
                clearTimeout(timer);
            };
        }
    }, [showPlaceBid]);

    const currentLot = lots[currentLotIndex];

    useEffect(()=>{
        getLeaderboardData()
        fetchLots()
    },[])

    return(
        <>
            {!loading && <LeaderBoardPreview 
                auctionData={auctionData} 
                lotData={lots} 
                showPlaceBid={showPlaceBid}
                currentPlaceBid={currentPlaceBid}
            />}
            {loading && (
                <div className="fixed inset-0 bg-[#E6E6E6] flex justify-center items-center z-[9999]">
                    <Triangle
                        height="80"
                        width="80"
                        color="#000"
                        ariaLabel="triangle-loading"
                        visible={true}
                    />
                </div>
            )}
        </>
    )
}

function LogoPreview({ auctionData}) {
    const leftLogo = auctionData?.event_display?.left_logo_image
    const rightLogo = auctionData?.event_display?.right_logo_image
    return (
        <div className="flex pb-4">
            {leftLogo &&
                <img src={`${config.Storage.CDN}${leftLogo}`} className="w-[100px] object-cover" alt="Left Logo" /> 
            }
            <div className="flex-grow" />
            {rightLogo &&
                <img src={`${config.Storage.CDN}${rightLogo}`} className="w-[100px] object-cover" alt="Right Logo" /> 
            }
        </div>
    )
}

export function LeaderBoardPreview({ auctionData, lotData = [], showPlaceBid, currentPlaceBid }) {
    const backgroundColor = auctionData?.event_display?.background_color
    const backgroundImage = auctionData?.event_display?.background_image
    const [isScrollingDown, setIsScrollingDown] = useState(true);
    const [scrollSpeed, setScrollSpeed] = useState(1); // pixels per frame (60fps = 60px/second) - minimum 1px for browser compatibility
    const [lastScrollTop, setLastScrollTop] = useState(0);
    const [stuckCounter, setStuckCounter] = useState(0);

    // Reset scroll position when data changes
    useEffect(() => {
        if (lotData.length > 0) {
            // Reset to top and start scrolling down
            window.scrollTo(0, 0);
            setIsScrollingDown(true);
        }
    }, [lotData.length]);

    // Auto-scroll effect - down then up, creating infinite loop (page-level scrolling)
    useEffect(() => {
        if (lotData.length === 0 || showPlaceBid) {
            return;
        }

        // Check if there's enough content to warrant scrolling
        const estimatedContentHeight = lotData.length * (100 + 21) + 200; // 100px per lot + 21px gap + extra padding
        const viewportHeight = window.innerHeight;
        
        if (estimatedContentHeight <= viewportHeight) {
            return;
        }

        const interval = setInterval(() => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight;
            const clientHeight = window.innerHeight;
            const maxScroll = scrollHeight - clientHeight;

            // Double-check: If there's actually no scrollable content, stop auto-scrolling
            if (maxScroll <= 10) { // Allow margin for browser differences and other content
                return;
            }

            // Check if scroll position is stuck
            if (Math.abs(scrollTop - lastScrollTop) < 0.5) {
                setStuckCounter(prev => prev + 1);
                if (stuckCounter > 3) { // If stuck for 3 frames, act quickly
                    if (isScrollingDown) {
                        window.scrollTo(0, scrollTop + Math.max(scrollSpeed * 2, 2)); // Force bigger movement
                    } else {
                        window.scrollTo(0, Math.max(scrollTop - Math.max(scrollSpeed * 2, 2), 0)); // Force bigger movement
                    }
                    setStuckCounter(0);
                    return; // Skip normal scrolling this frame
                }
            } else {
                setStuckCounter(0);
            }
            setLastScrollTop(scrollTop);

            if (isScrollingDown) {
                // Scrolling down
                if (scrollTop >= maxScroll - 5) { // Use -5 for better threshold
                    // Reached bottom, start scrolling up
                    setIsScrollingDown(false);
                    // Immediately start scrolling up to avoid getting stuck
                    window.scrollTo(0, Math.max(scrollTop - scrollSpeed, 0));
                } else {
                    // Continue scrolling down
                    window.scrollTo(0, Math.min(scrollTop + scrollSpeed, maxScroll));
                }
            } else {
                // Scrolling up
                if (scrollTop <= 5) { // Use 5 for better threshold
                    // Reached top, start scrolling down
                    setIsScrollingDown(true);
                    // Immediately start scrolling down to avoid getting stuck
                    window.scrollTo(0, scrollTop + scrollSpeed);
                } else {
                    // Continue scrolling up
                    const newScrollTop = Math.max(scrollTop - scrollSpeed, 0);
                    window.scrollTo(0, newScrollTop);
                }
            }
        }, 1000 / 60); // 60fps

        return () => clearInterval(interval);
    }, [lotData.length, scrollSpeed, isScrollingDown, showPlaceBid]);

    return (
        <>
            <div
                className="px-6 py-10 relative bg-cover min-h-screen flex flex-col"
                style={{
                    backgroundColor,
                    backgroundImage: `url(${config.Storage.CDN}${backgroundImage})`,
                }}
            >
                <LogoPreview auctionData={auctionData} />
                {showPlaceBid && currentPlaceBid && (
                    <PlaceBidCard currentLot={currentPlaceBid} currency={auctionData.currency} />
                )}
                {!showPlaceBid && (
                    <div className="flex-1 relative">
                        <div className="flex flex-col gap-[21px] pb-8">
                            {lotData.map((lot) => (
                                <div key={lot._id} className="flex items-center h-[100px] rounded-lg w-full shadow-md bg-white/95 backdrop-blur-sm">
                                    <div className="w-[100px] h-full bg-black flex flex-col items-center justify-center rounded-l-md">
                                        <div className="text-sm text-white font-bold">Lot {lot.lot_number}</div>
                                    </div>
                                    <div className="w-[200px] h-full bg-gray-200 border-r-[1px] border-r-gray-600
                                        flex flex-col items-center justify-center gap-1 "
                                    >
                                        <div className="text-ls font-bold">
                                            {!lot.current_bid || lot.current_bid == 0 ? 'STARTING BID' : 'CURRENT BID'}
                                        </div>
                                        <div className="text-lg font-semibold text-gray-700">
                                            {Number(!lot.current_bid || lot.current_bid == 0 
                                                ? lot.starting_price : 
                                                lot.current_bid).toLocaleString(auctionData.currency ==='INR' ? 'en-IN' : 'en-US', {
                                                style: 'currency',
                                                currency: auctionData.currency,
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0,
                                            })}
                                        </div>
                                        <div className="text-xs">PADDLE {lot.paddle_number}</div>
                                    </div>
                                    <div className="h-full flex-grow bg-white text-lg font-medium flex items-center justify-center px-4">
                                        {lot.title1}
                                    </div>
                                    <div className="h-full">
                                        <img
                                            className="w-[169px] h-full object-cover"
                                            src={`${config.Storage.CDN}${lot.images.find((image) => image.featured).url}`} 
                                            alt="Lot Image"
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                <div className="absolute bottom-1 right-10 text-white">
                    <span className="text-xs">{"Powered by "}</span>
                    <span className="text-lg font-bold">Indy</span>
                    <span className="text-lg font-normal">.auction</span>
                </div>
            </div>
        </>
    )
}